/**
 * The "Book a demo" button, and the owner of the dialog's open state.
 *
 * Sits beside the Quick Tour launcher in the same header slot: the two are the
 * pair of things a sandbox visitor can do — look around on their own, or ask to be
 * shown. Neither knows about the other.
 *
 * The dialog is mounted only while open. It is a large iframe of a live booking
 * page, so keeping it mounted-but-hidden would load that page (and hold a
 * cross-origin document) for every user who never asked for a demo.
 */

import React, { useState } from 'react';

import { DemoBookingDialog } from './DemoBookingDialog';

export function DemoBookingButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="tour-guide-launcher tour-guide-launcher--demo"
        data-testid="demo-booking-button"
        aria-label="Book a live demo with the WeNext team"
        aria-haspopup="dialog"
        aria-expanded={open}
        /* No `title` — the label doubles as the tooltip; see `TourLauncher`. */
        onClick={() => setOpen(true)}
      >
        {/* Inlined so the module carries no icon-library dependency. */}
        <svg
          className="tour-guide-launcher__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        <span className="tour-guide-launcher__label">Demo</span>
      </button>

      {open && <DemoBookingDialog onClose={() => setOpen(false)} />}
    </>
  );
}
